import {createContract} from 'interactors/contracts';
import {MessageType} from './const';

const messageMustHaveName = (message: Message): boolean => !!message.name;
const messageMustBeOfKnownType = (message: Message): boolean => message.type in MessageType;

export const MessageContract = createContract({
  require: [
    [messageMustHaveName, 'Message name required'],
    [messageMustBeOfKnownType, 'Unknown message type'],
  ],
});
